/* eslint-disable import/no-named-as-default-member */
import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import IconFlagReport from "../../../../../public/assets/icons/IconFlagReport";
import ModalComplain from "../../../questionAndAnswer/components/ModalComplain";
import AlertDialog from "../../dialog/AlertDialog";
import GoogleAdDialog from "../../dialog/GoogleAdDialog";
import { REPORT_QUIZ, quizAnswerType } from "../../utils/constant";
import { ShowBasicDataContent } from "../Elements";
import OneAnswerCard from "./OneAnswerCard";
import SelectionsCard from "./SelectionsCard";
import SortPositionCard from "./SortPositionCard";
import SwitchDataContent from "./SwitchDataContent";

import { eventTracking } from "../../../../firebase/firebaseConfig";
import { TTheme } from "../../../../utils/configs/setupTheme";
import { isEmpty } from "../../../../utils/helpers/helpers";
import { commonActions } from "../../redux/actions";
import { TCommonState } from "../../utils/type";
import ManyAnswerCard from "./ManyAnswerCard";
import ConstructedResponseCard from "./ConstructedResponseCard";

function QuestionRow({
  element,
  index,
  practice,
  answerTotalQuestion,
  quizInfoSolutions,
  chooseAnswerOfOneAnswerQuestion,
  chooseAnswerOfManyAnswerQuestion,
  addDataToState,
  setQuizInfoSolutions,
  addDataToStateSortPosition,
  onChangeAnswerConstructedResponse,
  setIsDynamicMathJax,
  isArena,
  isParentGroup
}: any) {
  const theme: TTheme = useTheme();
  const dispatch = useDispatch();
  const [openGgAd, setOpenGgAd] = React.useState(false);
  const [openAlertDialog, setOpenAlertDialog] = React.useState(false);
  const [showSolutions, setShowSolutions] = React.useState(false);
  const [openModalReport, setOpenModalReport] = React.useState(false);
  const dataUserInfos = useSelector((state: { commonNew: TCommonState }) => state.commonNew.userInfos);
  const hideDialogSurvey = useSelector((state: { commonNew: TCommonState }) => state.commonNew.hideDialogSurvey);

  if (element?.answer_type === -1) return null;

  const handleOpenModalReport = () => {
    setOpenModalReport(true);
  };
  const handleCloseModalReport = () => {
    setOpenModalReport(false);
  };
  // eslint-disable-next-line react-hooks/rules-of-hooks
  React.useEffect(() => {
    if (hideDialogSurvey !== openModalReport) {
      dispatch(commonActions.handleHideDialogSurvey(openModalReport));
    }
  }, [openModalReport]);

  const switchDataContentChild = () => {
    if (!isParentGroup && element?.parent && practice?.items?.find((e: { id: any }) => e.id === element.parent)) {
      return element?.questions.map((ele: any, idx: number) => <SwitchDataContent ele={ele} key={idx} />);
    }
    if (element?.questions?.length === 0) {
      return <div className="mt-2">Câu {index + 1}:</div>;
    }
    return element?.questions?.map((ele: any, eleIndex: number) => (
      <SwitchDataContent key={eleIndex} ele={ele} index={index} ix={eleIndex} />
    ));
  };
  const solutionsItems = quizInfoSolutions?.solutions?.find(
    (v: { quiz_question_id: number }) => v?.quiz_question_id === element?.id
  )?.items;
  

  return (
    <div className="md:w-full sm:w-screen" style={{ boxSizing: "border-box" }} id={element?.id}>
      <div className="flex items-start">
        <Box className="flex justify-start flex-col md:w-full sm:w-screen sm:overflow-x-auto md:overflow-visible scrollbar-hide">
          {!isParentGroup && practice?.items
            ?.find((e: { id: any }) => e.id === element.parent)
            ?.questions.map((parent: any, parentIndex: number) => (
              <SwitchDataContent ele={parent} index={index} ix={parentIndex} key={parentIndex} />
            ))}
          <span className={`font-semibold ${isParentGroup && "px-8"}`}>{switchDataContentChild()}</span>
        </Box>
        {dataUserInfos?.member && (
          <button
            type="button"
            className="block ml-[10px] mt-[10px] sm:mr-[13px] md:mr-0 cursor-pointer"
            onClick={() => eventTracking("select_quiz_error", {}, () => handleOpenModalReport())}
          >
            <IconFlagReport />
          </button>
        )}
      </div>

      <div
        className={`sm:w-screen md:w-full sm:flex sm:flex-col md:flex md:flex-wrap my-4 mx-auto h-full justify-start ${
          element?.answer_type === quizAnswerType.ONE_ANSWER || element?.answer_type === quizAnswerType.MANY_ANSWER
            ? "2xl:grid 2xl:grid-cols-2 justify-items-center"
            : ""
        }  ${isParentGroup && "px-8"}`}
      >
        {(() => {
          switch (element?.answer_type) {
            case quizAnswerType.SORT_POSITION:
              return (
                <SortPositionCard
                  answerTotalQuestion={answerTotalQuestion}
                  options={element?.options}
                  addDataToStateSortPosition={addDataToStateSortPosition}
                  solutionData={quizInfoSolutions?.results?.find(
                    (v: { quiz_question_id: any }) => v.quiz_question_id === element?.id
                  )}
                  questionId={element?.id}
                />
              );
            case quizAnswerType.CONSTRUCTED_RESPONSE:
              return (
                <ConstructedResponseCard
                  answerTotalQuestion={answerTotalQuestion}
                  question={element}
                  solutionData={quizInfoSolutions?.results?.find(
                    (v: { quiz_question_id: any }) => v.quiz_question_id === element?.id
                  )}
                  onChangeAnswer={onChangeAnswerConstructedResponse}
                />
              );
            case quizAnswerType.ONE_ANSWER:
            case quizAnswerType.MANY_ANSWER:
            default:
              return element.options.map(
                (el: { items: { content_type: string; content: string }[]; id: any }, ix: number) => (
                  <Box
                    key={ix}
                    display="flex"
                    justifyContent="space-around"
                    style={{
                      width: el?.items[0]?.content.includes("selections") ? "100%" : undefined,
                      minWidth: 320,
                      marginBottom: 16
                    }}
                  >
                    {(() => {
                      switch (element?.answer_type) {
                        case quizAnswerType.ONE_ANSWER: {
                          return (
                            <OneAnswerCard
                              questionId={element?.id}
                              selectionsId={el.id}
                              ix={ix}
                              items={el?.items}
                              solutionData={quizInfoSolutions?.results?.find(
                                (v: { quiz_question_id: any }) => v.quiz_question_id === element?.id
                              )}
                              answerTotalQuestion={answerTotalQuestion}
                              chooseAnswer={chooseAnswerOfOneAnswerQuestion}
                              // contentType={el?.items[0]?.content_type}
                            />
                          );
                        }
                        case quizAnswerType.MANY_ANSWER: {
                          return (
                            <ManyAnswerCard
                              questionId={element?.id}
                              selectionId={el.id}
                              ix={ix}
                              items={el?.items}
                              solutionData={quizInfoSolutions?.results?.find(
                                (v: { quiz_question_id: any }) => v.quiz_question_id === element?.id
                              )}
                              answerTotalQuestion={answerTotalQuestion}
                              chooseAnswer={chooseAnswerOfManyAnswerQuestion}
                            />
                          );
                        }
                        default: {
                          return (
                            <SelectionsCard
                              answerTotalQuestion={answerTotalQuestion}
                              selectionData={el?.items[0]?.content}
                              question={element}
                              questionId={element?.id}
                              addDataToState={addDataToState}
                              solutionData={quizInfoSolutions?.results?.find(
                                (v: { quiz_question_id: any }) => v.quiz_question_id === element?.id
                              )}
                              answerType={element?.answer_type}
                            />
                          );
                        }
                      }
                    })()}
                  </Box>
                )
              );
          }
        })()}
      </div>
      {!isEmpty(
        quizInfoSolutions?.solutions?.find((v: { quiz_question_id: any }) => v?.quiz_question_id === element?.id)?.items
          ?.detail
      ) && (
        <Box
          className="sm:w-screen md:w-full flex justify-end"
          onClick={() => {
            if (quizInfoSolutions?.is_show_solution) {
              setShowSolutions(!showSolutions);
            } else {
              setOpenAlertDialog(true);
            }
            setIsDynamicMathJax(true);
          }}
        >
          <Typography
            className="sm:mr-4 md:mr-0"
            variant="subtitle2"
            style={{
              color: theme.palette.secondary.main,
              textTransform: "uppercase",
              cursor: "pointer"
            }}
          >
            <FormattedMessage id="ExamQuestion.solutionGuide" />
          </Typography>
        </Box>
      )}
      <Box
        className={`flex flex-col sm:w-[96vw] md:w-full sm:overflow-x-auto md:overflow-visible scrollbar-hide ${
          showSolutions ? "inline" : "hidden"
        }`}
      >
        {solutionsItems?.suggestion &&
          solutionsItems?.suggestion?.map((solution, idx) => (
            <div key={idx} className="flex flex-col">
              <ShowBasicDataContent ele={solution} isArena={isArena} />
            </div>
          ))}
        {solutionsItems?.detail &&
          solutionsItems?.detail?.map((solution, idx) => (
            <div key={idx} className="flex flex-col">
              <ShowBasicDataContent ele={solution} isArena={isArena} />
            </div>
          ))}
      </Box>
      {openGgAd && <GoogleAdDialog open={openGgAd} setOpen={setOpenGgAd} triggerFunc={() => setShowSolutions(true)} />}
      {openAlertDialog && (
        <AlertDialog
          open={openAlertDialog}
          setOpen={setOpenAlertDialog}
          title="Thông báo"
          triggerFunc={() => {
            setOpenGgAd(true);
            setQuizInfoSolutions({
              ...quizInfoSolutions,
              is_show_solution: true
            });
            eventTracking("select_ic_play_video");
          }}
          contentKey="ExamQuestion.solutionTitle"
          styleContent={{ textAlign: "center", width: "100%" }}
          buttonOkKey="IDS_View_Ads"
        />
      )}
      {openModalReport && (
        <ModalComplain
          open={openModalReport}
          handleClose={handleCloseModalReport}
          title={<FormattedMessage id="title.report.quiz" />}
          subtitle={<FormattedMessage id="subtitle.report.quiz" />}
          type={REPORT_QUIZ}
          questionId={element?.id}
          openTextInput
          setOpenModalReport={setOpenModalReport}
          isArena={isArena}
          hasInputImage
        />
      )}
    </div>
  );
}

export default React.memo(QuestionRow);
